//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { RightsRequestOptions } from '@legacy-components/common/universal-image-actions/constants/universalImageActionsRightsRequestContstants';
import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import Cuid from '@models/Cuid';
import { useMediaMetadataQuery } from '@uia/details/hooks/useMediaMetadataQuery';
import { ChooseMessageCapabilities } from '@uia/rights/choose-message/ChooseMessageCapabilities';
import { ChooseMessageSelect } from '@uia/rights/choose-message/ChooseMessageSelect';
import { ChooseMessageTCUrl } from '@uia/rights/choose-message/ChooseMessageTCUrl';
import { getRightsRequestDetailsWithSyndicationCheck } from '@uia/rights/utils/rightsRequestUtils';
import { checkIsStatusInitiated } from '@uia/rights/utils/statusUtils';

export interface ChooseMessageProps {
  cuid: Cuid;
  requestType: RightsRequestOptions;
  rightsRequestText: string | undefined;
  selectedOption: IRightsOption | undefined;
  setSelectedOption: (selectedOption: IRightsOption) => void;
}

export const ChooseMessageType = ({
  cuid,
  requestType,
  rightsRequestText,
  selectedOption,
  setSelectedOption,
}: ChooseMessageProps) => {
  const {
    data: metadata,
    isError: isErrorMetadata,
    isPending: isPendingMetadata,
  } = useMediaMetadataQuery(cuid);

  if (isPendingMetadata || isErrorMetadata) {
    return null;
  }

  const { status } = getRightsRequestDetailsWithSyndicationCheck(metadata);

  const areRightsAlreadyRequested = checkIsStatusInitiated(status);

  return (
    <>
      <ChooseMessageCapabilities cuid={cuid} requestType={requestType} />
      <ChooseMessageTCUrl cuid={cuid} rightsRequestText={rightsRequestText} />
      {!areRightsAlreadyRequested && (
        <ChooseMessageSelect
          cuid={cuid}
          requestType={requestType}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      )}
    </>
  );
};
